const HappinessMarker = () => {
    return (
        <svg width="8" height="16" viewBox="0 0 8 16" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1" width="6" height="14" rx="1" ry="1" fill="#0B1423" stroke="#F7F7F8FF" strokeWidth="2"/>
        </svg>

    );
};

export default HappinessMarker;